<template>
  <tr
    v-if="viewPort == 'large'"
    :class="{
      'requested': itemRequested
    }"
  >
    <td
      v-if="checkboxes"
      class="checkbox"
    >
      <checkbox-block
        v-model="curMail.active"
        :class="{
          'disabled': itemProcessed
        }"
        @input.native="$emit('remove-selection')"
      >
      </checkbox-block>
    </td>
    <td class="number">{{curMail.mail_number}}</td>
    <td class="sm-txt-center pmb">
      <a
        href="#"
        class="sm-link-text"
        @click.prevent="$router.push(`/admin/customer/${curMail.account_id}`)"
      >{{curMail[activeCustomerColumn]}}</a>
    </td>
    <td>
      <a
        href="#"
        class="sm-link-text"
        @click.prevent="$router.push(`/admin/mail-edit?mail_number=${curMail.mail_number}`)"
      >
        <text-truncate
          :text="curMail.sender"
          :maxWidth="'180px'"
        />
      </a>
    </td>
    <td class="sm-txt-nowrap">{{curMail.received_at.split('T')[0] | moment('MMM D, YYYY')}}</td>
    <td class="sm-txt-capitalize">{{curMail.type}}</td>
    <td class="sm-txt-center qty">{{curMail.quantity}}</td>
    <td class="sm-txt-nowrap">{{curMail.requested_date | moment('MMM D, YYYY')}}</td>
    <td class="status">
      <status-progress :mail="curMail"></status-progress>

      <span
        v-for="(status, index) in parsedMailStatuses"
        :key="status.value"
        :class="status.class"
      >{{status.value}}{{shouldInsertComma(index, status) ? ', ' : ''}}</span>
      <hint-wrap
        v-if="curMail.tracking_code"
        :text="'View tracking code'"
        :delay="0"
      >
        <template slot="content">
          <a
            href="#"
            class="sm-link"
            @click.prevent="openTrackingCode"
          >
            <include-svg :name="'icon-tracking'" />
          </a>
        </template>
      </hint-wrap>
    </td>
    <td>
      <div
        v-if="actions"
        class="sm-list__table-actions"
      >
        <template v-if="!curMail.mark_as_pick_up_requested || curMail.mark_as_pick_up_complete">
          <div
            v-for="action in curMail.actionStatus.actions"
            :key="action.name"
            class="sm-list__table-action"
            @mouseenter="actionEnter(action)"
            @mouseleave="actionLeave(action)"
          >
            <a
              v-if="(!action.processed && !action.restriction) || action.name == 'edit'"
              href="#"
              class="icon"
              @click.prevent="$emit('action', {
                id: curMail.id,
                action: action.name,
              })"
            >
              <template v-if="!action.admin_status || curMail.status != action.admin_status.value">
                <include-svg :name="action.btn.icon" />
                <hint-block v-if="action.showHint">
                  <template slot="hintContent">{{action.btn.textAdmin || action.btn.text}}</template>
                </hint-block>
              </template>
              <template v-else>
                <include-svg :name="action.admin_status.icon" />
                <hint-block v-if="action.showHint">
                  <template slot="hintContent">{{action.admin_status.text}}</template>
                </hint-block>
              </template>
            </a>

            <a
              v-else-if="action.result && curMail[action.result.field] && (action.name != 'scan' || !action.restriction)"
              :href="curMail[action.result.field]"
              target="_blank"
              class="result"
              :class="{
                'picture': action.name == 'picture'
              }"
            >
              <scan-preview
                v-if="action.name == 'scan'"
                :src="curMail[action.result.field]"
                :showHint="action.showHint"
              />
              <img-preview
                v-if="action.name == 'picture'"
                :src="curMail[action.result.field]"
                :showHint="action.showHint"
                :isRequested="mail.picture_requested_at ? true : false"
              />
            </a>

            <a v-else href="#" class="icon disabled">
              <include-svg :name="action.btn.icon" />
              <hint-block v-if="action.showHint && (action.processed || action.restriction)">
                <template slot="hintContent">{{action.processed || action.restriction}}</template>
              </hint-block>
            </a>
          </div>
        </template>
        <template v-else>
          <div
            v-for="action in curMail.actionStatus.customer_pick_actions"
            :key="action.name"
            class="sm-list__table-action"
            @mouseenter="actionEnter(action)"
            @mouseleave="actionLeave(action)"
          >
            <a
              href="#"
              class="icon"
              @click.prevent="$emit('action', {
                id: curMail.id,
                action: action.name,
              })"
            >
              <include-svg :name="action.btn.icon" />
              <hint-block v-if="action.showHint">
                <template slot="hintContent">{{action.btn.text}}</template>
              </hint-block>
            </a>
          </div>
        </template>
      </div>

      <div
        v-if="actions"
        class="sm-list__table-actions-mobile"
        @click="showPopup"
      >
        <a href="#"></a>
      </div>
      <div class="sm-list__table-actions-popup"
        v-if="curMail.popupOpen"
        v-click-outside="hidePopup">
        <ul>
          <template v-if="!curMail.mark_as_pick_up_requested || curMail.mark_as_pick_up_complete">
            <li
              v-for="(action, index) in curMail.actionStatus.actions"
              :key="action.name"
              :class="index == 2 ? 'delimiter' : ''"
            >
              <a
                v-if="(!action.processed && !action.restriction) || action.name == 'edit'"
                href="#"
                @click.prevent="$emit('action', {
                  id: curMail.id,
                  action: action.name,
                })"
              >
                <template v-if="!action.admin_status || curMail.status != action.admin_status.value">
                  {{action.btn.textAdmin || action.btn.text}}
                </template>
                <template v-else>
                  {{action.admin_status.text}}
                </template>
              </a>
              <a
                v-else-if="action.result && curMail[action.result.field] && !action.restriction"
                :href="curMail[action.result.field]"
                class="result"
                target="_blank"
              >{{action.result.text}} {{ !mail.picture_requested_at && '(pending customer request)'}}</a>

              <span v-else>{{action.btn.text}}</span>
            </li>
          </template>
          <template v-else>
            <li
              v-for="action in curMail.actionStatus.customer_pick_actions"
              :key="action.name"
            >
              <a
                href="#"
                @click.prevent="$emit('action', {
                  id: curMail.id,
                  action: action.name,
                })"
              >
                <template v-if="!action.admin_status || curMail.status != action.admin_status.value">
                  {{action.btn.textAdmin || action.btn.text}}
                </template>
                <template v-else>
                  {{action.admin_status.text}}
                </template>
              </a>
            </li>
          </template>
        </ul>
      </div>
    </td>
  </tr>
  <div
    v-else
    class="sm-mobile-table-item"
    :class="{
      'open': curMail.itemOpen,
      'requested': itemRequested
    }"
    @touchstart="touchStart"
    @touchend="touchEnd"
  >
    <div
      class="sm-mobile-table-item-row"
      :class="curMail.active ? 'active' : ''"
    >
      <div
        class="sm-mobile-table-item-row-elem sender"
        @click="toggleItem"
      >
        <include-svg :name="'icon-arrow-b-bold'" />
        <text-truncate :text="curMail.sender" />
      </div>
      <div class="sm-mobile-table-item-row-elem pmb sm-txt-center">
        <a
          href="#"
          class="sm-link-text"
          @click.prevent="$router.push(`/admin/customer/${curMail.account_id}`)"
        >{{curMail.account_number}}</a>
      </div>
      <div
        class="sm-mobile-table-item-row-elem date"
        :class="{'no-actions': !actions}"
      >
        <template v-if="viewPort != 'small'">{{curMail.received_at.split('T')[0] | moment('MMM D, YYYY')}}</template>
        <template v-else>{{curMail.received_at.split('T')[0] | moment('MMM D')}}</template>
      </div>
      <!-- <div
        class="sm-mobile-table-item-row-elem date"
        :class="{'no-actions': !actions}"
      >
        <template v-if="viewPort != 'small'">{{curMail.received_at.split('T')[0] | moment('MMM D, YYYY')}}</template>
        <template v-else>{{curMail.received_at.split('T')[0] | moment('MMM D')}}</template>
      </div> -->
      <div
        v-if="actions"
        class="sm-mobile-table-item-row-elem actions"
        @click="showPopup"
      >
        <a href="#"></a>
      </div>
    </div>
    <ul class="sm-mobile-table-item-dropdown">
      <li>
        <span>ID</span>
        <span>{{curMail.mail_number}}</span>
      </li>
      <li>
        <span>Type</span>
        <span class="sm-txt-capitalize">{{curMail.type}}</span>
      </li>
      <li>
        <span>Qty.</span>
        <span>{{curMail.quantity}}</span>
      </li>
      <li>
        <span>Request Date</span>
        <span>{{curMail.requested_date | moment('MMM D, YYYY')}}</span>
      </li>
      <li>
        <span>Status</span>
        <span class="status">
          <status-progress :mail="curMail"></status-progress>
          <span
            v-for="status in parsedMailStatuses"
            :key="status.value"
            :class="status.class"
          >{{status.value}}</span>
          <a
            v-if="curMail.tracking_code"
            href="#"
            class="sm-link"
            @click.prevent="openTrackingCode"
          >
            <include-svg :name="'icon-tracking'" />
          </a>
        </span>
      </li>
    </ul>
    <div
      class="sm-mobile-table-item-popup"
      v-if="curMail.popupOpen"
      v-click-outside="hidePopup"
    >
      <ul>
        <template v-if="!curMail.mark_as_pick_up_requested || curMail.mark_as_pick_up_complete">
          <li
            v-for="(action, index) in curMail.actionStatus.actions"
            :key="action.name"
            :class="index == 2 ? 'delimiter' : ''"
          >
            <a
              v-if="(!action.processed && !action.restriction) || action.name == 'edit'"
              href="#"
              @click.prevent="$emit('action', {
                id: curMail.id,
                action: action.name,
              })"
            >
              <template v-if="!action.admin_status || curMail.status != action.admin_status.value">
                {{action.btn.textAdmin || action.btn.text}}
              </template>
              <template v-else>
                {{action.admin_status.text}}
              </template>
            </a>
            <a
                v-else-if="action.result && curMail[action.result.field] && !action.restriction"
                :href="curMail[action.result.field]"
                class="result"
                target="_blank"
              >{{action.result.text}}</a>
            <span v-else>{{action.btn.text}}</span>
          </li>
        </template>
        <template v-else>
          <li
            v-for="action in curMail.actionStatus.customer_pick_actions"
            :key="action.name"
          >
            <a
              href="#"
              @click.prevent="$emit('action', {
                id: curMail.id,
                action: action.name,
              })"
            >
              <template v-if="!action.admin_status || curMail.status != action.admin_status.value">
                {{action.btn.textAdmin || action.btn.text}}
              </template>
              <template v-else>
                {{action.admin_status.text}}
              </template>
            </a>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkboxes.vue';
import Hint from '@/components/Hint.vue';
import HintWrap from '@/components/HintWrap';
import vClickOutside from 'v-click-outside';
import MailParams from '@/settings/mail';
import ViewPort from '@/mixins/ViewPort';
import ImgPreview from '@/components/ImgPreview';
import ScanPreview from '@/components/mail/ScanPreview';
import StatusProgress from '@/components/mail/StatusProgress';
import parseStatuses from '@/utils/parseMailStatuses';

export default {
  name: "item-mail",
  components: {
    'checkbox-block': Checkbox,
    'hint-block': Hint,
    'hint-wrap': HintWrap,
    'img-preview': ImgPreview,
    'scan-preview': ScanPreview,
    'status-progress': StatusProgress
  },
  props: {
    mail: {
      type: Object,
      required: true
    },
    groupSelection: {
      type: Boolean,
      default: false
    },
    checkboxes: {
      type: Boolean,
      default: true
    },
    actions: {
      type: Boolean,
      default: true
    },
    startActive: {
      type: Boolean,
      default: false
    },
    activeCustomerColumn: {
      type: String,
      default: 'account_number'
    }
  },
  data() {
    return {
      timer: null,
      curMail: {},
      allowedBreakpoints: [
        'small',
        'medium',
        'large'
      ],
      mailRequests: {
        urgent: [
          'Same Day Scan requested',
          'Two Days Scan requested',
          'Expedited forward requested'
        ],
        regular: [
          'Shred requested',
          'Scanned',
          'Stored',
          'Scan requested',
          'Forward requested',
          'Expedited forward requested',
          'Envelope picture requested',
          'Pick up requested',
          'Mark as pick up requested',
          'Mark as junk',
          'Marked as pick up requested by the user',
          'Check deposit requested',
          'Stored'
        ]
      },
      terminalMailActions: ['Picked up' , 'Mail forwarded' , 'Shredded'],
      itemRequested: false,
    }
  },
  created() {
    this.curMail = this.prepareMail(this.mail);
  },
  computed: {
    itemProcessed() {
      return (
        this.curMail.is_forward_complete ||
        this.curMail.is_pick_up_complete ||
        this.curMail.mark_as_pick_up_complete ||
        this.curMail.is_shred_complete ||
        this.curMail.is_junk
      );
    },
    parsedMailStatuses() {
      return parseStatuses(this.mail);
    },
  },
  mixins: [ViewPort],
  methods: {
    prepareMail(mail) {
      return {
        ...mail,
        actionStatus: this.prepareActions(mail),
        active: this.startActive,
        popupOpen: false,
        itemOpen: false
      };
    },
    prepareActions(mail) {
      let status = {};
      status.active = false;

      status.actions = [];

      if(mail.is_junk) {
         MailParams.available_actions.admin.junk.forEach(action => {
            let actionData = {...MailParams.actions[action]};

            status.actions.push({
              name: action,
              btn: actionData.btn,
              showHint: false
            });
          });
        return status
      }

      MailParams.available_actions.admin.single.forEach(action => {
        let actionData = {...MailParams.actions[action]};
        status.actions.push({
          name: action,
          processed: mail[actionData.data.processed.field] ? actionData.data.processed.text : false,
          btn: actionData.btn,
          result: actionData.data.result || null,
          admin_status: actionData.data.admin_status || null,
          restriction: this.checkItemRestrictions(mail, actionData),
          showHint: false
        });
      });

      status.customer_pick_actions = [];

      MailParams.available_actions.admin.customer_pick_up.forEach(action => {
        let actionData = {...MailParams.actions[action]};

        status.customer_pick_actions.push({
          name: action,
          btn: actionData.btn,
          showHint: false
        });
      });

      return status;
    },
    showPopup() {
      this.curMail.popupOpen = true;
    },
    hidePopup() {
      this.curMail.popupOpen = false;
    },
    toggleItem() {
      this.curMail.itemOpen = !this.curMail.itemOpen;
    },
    actionEnter(action) {
      this.timer = setTimeout(() => {
        action.showHint = true;
      }, 500);
    },
    actionLeave(action) {
      action.showHint = false;
      clearTimeout(this.timer);
    },
    setActive(val) {
      this.curMail.active = val;
    },
    touchStart() {
      this.timer = setTimeout(() => {
        this.curMail.active = !this.curMail.active;
      }, 500);
    },
    touchEnd() {
      clearTimeout(this.timer);
    },
    checkItemRestrictions(item, actionData) {
      if (actionData.data.conditions) {
        let res = false;

        if (actionData.data.conditions.item) {
          // res = actionData.data.conditions.item.find(_item => !item[_item.field]);
          res = actionData.data.conditions.item.find(_item => {
            if (!_item.onlyCustomer) {
              if (_item.not) return item[_item.field];
              else return !item[_item.field];
            }
          });
          if (res)
            return res.text;
        }
      }

      let processedAction = MailParams.nonRevertableActions.find(action => item[MailParams.actions[action].data.processed.field]);

      if (processedAction && actionData.name != processedAction)
        return `Can't process action, item is ${MailParams.actions[processedAction].data.processed.text}`;

      return false;
    },
    openTrackingCode() {
      this.$router.push(`/admin/tracking?item=${this.curMail.mail_number}`);
    },
    shouldInsertComma(index, status) {
      return index < this.parsedMailStatuses.length - 1 && !status.class;
    },
  },
  watch: {
    'curMail.active'(val) {
      this.$emit('change-selection', {
        id: this.curMail.id,
        mail_number: this.curMail.mail_number,
        account_id: this.curMail.account_id,
        sender: this.curMail.sender,
        customer_full_name: this.curMail.customer_full_name,
        customer_company_name: this.curMail.customer_company_name,
        received_at: this.curMail.received_at,
        val: val
      });
    },
    mail(val) {
      this.curMail = this.prepareMail(val);
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
};
</script>
